import { escolas_que_nao_permitem_transferencia } from "./escolas-que-nao-permitem-transferencia";
import { escolas_que_nao_retornam_vagas } from "./escolas-que-nao-retornam-vagas";
import { escolas_e_ensinos_ministrados } from "./escolas-e-ensinos-ministrados";
import { escolas_ensinos_fases_turnos_ministrados } from "./escolas-ensinos-fases-turnos-ministrados";

const relatorio_de_apoio_gerencial_escola = [
  escolas_que_nao_permitem_transferencia,
  escolas_que_nao_retornam_vagas,
  escolas_e_ensinos_ministrados,
  escolas_ensinos_fases_turnos_ministrados,
];

export { relatorio_de_apoio_gerencial_escola };
